import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { onboarding } from "../mock";
import { ChevronRight } from "lucide-react";

export default function Onboarding() {
  const navigate = useNavigate();
  const [i, setI] = useState(0);
  const slide = onboarding[i];
  const last = i === onboarding.length - 1;

  const next = () => (last ? navigate("/auth") : setI(i + 1));

  return (
    <div className="gd-screen" style={{ background: "#2f47a8" }}>
      {/* full-bleed illustration mockup */}
      <img key={i} src={slide.img} alt={slide.title} className="gd-enter absolute inset-0 h-full w-full object-cover" />

      {/* tap anywhere to advance */}
      <button onClick={next} aria-label="Continue" className="absolute inset-0 z-0 bg-transparent" />

      {/* skip (top-right) */}
      <button onClick={() => navigate("/auth")} className="absolute right-5 top-6 z-20 rounded-full bg-black/25 px-4 py-1.5 text-xs font-bold text-white/90 backdrop-blur gd-tap">
        Skip
      </button>

      {/* next hint */}
      <button onClick={next} className="absolute bottom-7 right-6 z-20 grid h-11 w-11 place-items-center rounded-full text-white gd-tap"
        style={{ background: "rgba(255,255,255,0.18)", backdropFilter: "blur(6px)" }}>
        <ChevronRight size={22} />
      </button>
    </div>
  );
}
